<template>
  <div class="line-item" v-if="simulation"> 
      <div class="heading ml-2" style="display:flex;" @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE');">   
        <v-btn class="mx-0" small icon @click.prevent="$store.myActions.UI_TOGGLE_MISSION_MAP_VISIBILITY({missionId:mission.id,uiid:''})" :title="$t(missionMapVisibility[mission.id]?'Pilot.MissionDrawer.HideMissionTooltip':'Pilot.MissionDrawer.ShowMissionTooltip')"><v-icon>{{missionMapVisibility[mission.id]?'mdi-eye':'mdi-eye-off'}}</v-icon></v-btn>
        <!-- <mission-state :mission="mission" small/>         -->        
        <v-btn class="missionbtn mx-0 pr-2" :class="{'red--text darken-3':isError}" flat @click.prevent="$store.myActions.UI_TOGGLE_SIMULATION_INFOS_VISIBILITY({missionId:mission.id})"  :title="$t(missionDetailVisibility[mission.id]?'Pilot.MissionDrawer.HideMoreMissionInfosTooltip':'Pilot.MissionDrawer.ShowMoreMissionInfosTooltip')" >          
          <v-progress-circular v-if="isRunning" class="mr-2" :rotate="360" indeterminate color="primary" :size="18" :width="2" ></v-progress-circular>
          {{ simulationName }}          
          <v-icon :class="{rotate180:missionDetailVisibility[mission.id]}" style="margin-left:auto">mdi-chevron-down</v-icon>
        </v-btn>        
        <v-btn class="mx-0" small icon  @click.prevent="selectSimulationResult()" :title="$t('Pilot.MissionDrawer.SelectMissionTooltip')"><v-icon :class="{active:mission.id == bestFitMisId}">mdi-crosshairs-gps</v-icon></v-btn>        
        <mission-color class="mx-0" v-show="missionMapVisibility[mission.id]" :uiid="uiid" :mapUiid="map_uiid" :mission="mission.mission"  v-if="$vuetify.breakpoint.name != 'xs'"  />        
        <v-btn class="mx-0" small icon flat @click.stop.prevent="deleteSimulation()" ><v-progress-circular class="ml-2"  :size="20" v-if="deleting" indeterminate color="white"></v-progress-circular><v-icon v-else>mdi-delete</v-icon></v-btn>
        <v-btn class="mx-0" small :loading="setttingAsTemplate" icon flat @click="setAsTemplate()" :title="simulation.config.templateSimId == mission.id?$t('Pilot.MissionDrawer.IsTemplateRefTooltip'):$t('Pilot.MissionDrawer.SetAsTemplateRefTooltip')" ><v-icon  :class="{active:simulation.config.templateSimId == mission.id}">mdi-check-decagram-outline</v-icon></v-btn>
        
      </div>      
      <v-expand-transition>                      
        <simulation-mission-line-detail class="mx-1 mb-2 px-2 pb-2 pt-0" v-if="missionDetailVisibility[mission.id]" :mission="mission" typeUiid="detail" />                   
      </v-expand-transition>
  </div> 
</template>
<script lang="ts">


import { AloDbMission } from '@/models/alodb/AloDbMission'
import Vue from 'vue'
import Component from 'vue-class-component'
import { buildSimulationUIStateId,SimulationUiState } from '@/models/ui/SimulationUiState'
import { MapUiState } from '@/models/ui/MapUiState'
import { AloMission } from '@/models/alo/AloMission'
import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual'
import SimulationMissionLineDetail from '@/components/smart/SimulationMissionLineDetail.vue'
import MissionColor from '@/components/mission/MissionColor.vue'
import { AloDbMissionGlobal,AloDbMissionGlobalSimulation } from '@/models/alodb/AloDbMissionGlobal'
import { buildMissionPlanStateId } from '@/models/ui/MissionPlanUiState'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import {ISmartSimulation} from '@/models/iris/smartMission/ISmartSimulation'
import { MissionGlobalType } from '@/enum/MissionGlobalType'

@Component({
name: 'SimulationMissionLine',  
props:{  
  mission:{
    type:Object,
    required:true
  },  
  uiid:{
      type: String,
      required: true
  }
},
components:{SimulationMissionLineDetail,MissionColor}
})
export default class SimulationMissionLine extends Vue {      

  isTemplate!:boolean
  uiid!:string
  mission!:AloDbMissionVirtual

  setttingAsTemplate = false
  deleting = false
  
  
  //le composant n'est utilisé que si une missionGlobal est sélectionnée
  get simulation() {  
   return this.$store.myGetters.modifiedAdmMissionGlobal as AloDbMissionGlobalSimulation
  }

  get uistatebyuiid() {    
    return this.$store.myGetters.uistatebyuiid
  }

  get simulation_uiid() {
    return buildSimulationUIStateId(this.simulation.MIG_ID!,"detail")
  }

  get map_uiid() {
    return buildSimulationUIStateId(this.simulation.MIG_ID!,"map")
  }

  get simulationState() { 
    //retourne un MapUiState    
    return this.uistatebyuiid(this.simulation_uiid) as SimulationUiState         
  }

  get mapState() { 
    //retourne un MapUiState    
    return this.uistatebyuiid(this.map_uiid) as MapUiState         
  }

  get missionState() {  
    //retourne un MissionUiState                
    return this.$store.myGetters.uistatebyuiid(this.uiid)
  }

  get bestFitMisId(){
    return this.mapState?.bestFitMisId
  }
  
  get missionMapVisibility() {
    return this.$store.myGetters.missionMapVisibility
  }

  get missionDetailVisibility() {
    return this.$store.myGetters.missionDetailVisibility
  }  

  get isError(){
    return (this.mission?.result?.error_msg?.length ?? 0) > 0
  }
    
  get accesPilotReachDetail() {
    return true
  }

  get missionPlanUiid() {
    return buildMissionPlanStateId(this.simulation.MIG_ID || -1,"simulation")
  }

  get isRunning(){
    //TODO ameliorer avec enum
    return this.mission && (this.mission.result.simulation_state == 'running' || ((this.mission?.result?.simulation_state?.length ?? 0) == 0 && this.mission.VIM_STATUS >= 0 && this.mission.VIM_STATUS != 10))
  }
  
  get simulationName(){
    return `${this.simulation?.MIG_LIBELLE} #${this.mission.VIM_ITERATION?.toString().padStart(2,'0')}`
  }

  selectSimulationResult()  {    
    if(this.mission?.id) {
      //on copie la config courante sur celle de la mission global      
      this.simulation.config = {...AloDbMissionGlobal.parseSmartSimulation(this.mission.VIM_PARAM_JSON,MissionGlobalType.SIMULATION),templateSimId:this.simulation?.config?.templateSimId ?? null} as ISmartSimulation
      this.$store.myActions.UI_MISSIONPLAN_SET_MISSIONPLAN({
        uiid:this.missionPlanUiid,
        plan:this.simulation.config.mission_plan
      })
      this.$store.myActions.UI_SELECT_MISSION_MAP({id:this.mission.id,uiid:this.map_uiid})      
      this.$store.myActions.UI_SET_MISSION_MAP_VISIBILITY({missionId:this.mission.id,uiid:'',visible:true})
    }    
  }

  setAsTemplate() {
    if(this.simulation.config && this.simulation.config?.templateSimId != this.mission.id) {      
      this.setttingAsTemplate = true
      this.simulation.config.templateSimId = this.mission.id
      this.$store.myActions.MISSIONGLOBAL_SAVE_REQUEST().finally(()=> this.setttingAsTemplate = false)      
    }
  }

  
  async deleteSimulation() {
    if(!this.deleting) {
      const answer = await this.$confirm(this.$t('Simulation.DeleteDialogMessage',{name:this.simulationName}).toString(),{title: this.$t('Admin.Warning')} as VuetifyConfirmObject)
      if (answer) {
        //@ts-ignore
        this.deleting = true
        try{
          await this.$store.myActions.MISSIONVIRTUAL_DELETE_REQUEST(this.mission)
        }
        finally{
          this.deleting = false
        }        
      }    
    }
  }
}

</script> 

<style>

.rotate180{
  transform: rotate(-180deg);
}

.missionbtn .v-icon{
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)!important;
}

.testMission{
  font-style: italic;
  color: rgb(128, 128, 128)!important;
}

.line-item{
  border-bottom: 1px solid #eee;  
}
.line-item .active{
  color: #4caf50!important;  
}

.line-item .heading{
  display: flex;
  flex-direction: row;
  align-items: center;  
}

.missionbtn{
  flex:1 0 auto;
}

.missionbtn .v-btn__content{
  justify-content: flex-start;
}

</style>